import { useEffect, useState } from "react";

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

export const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const christmas = new Date(new Date().getFullYear(), 11, 25); // December 25
      const now = new Date();
      
      // If Christmas has passed this year, use next year
      if (now > christmas) {
        christmas.setFullYear(christmas.getFullYear() + 1);
      }
      
      const difference = christmas.getTime() - now.getTime();

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  const TimeBlock = ({ value, label }: { value: number; label: string }) => (
    <div className="flex flex-col items-center flex-1 min-w-0">
      <div className="relative bg-card/20 backdrop-blur-md border border-border/30 rounded-xl sm:rounded-2xl w-full py-2 sm:py-3 shadow-card overflow-hidden group">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        <span className="relative block text-lg sm:text-2xl md:text-3xl font-bold text-foreground font-serif tabular-nums text-center">
          {String(value).padStart(2, "0")}
        </span>
      </div>
      <span className="text-[8px] sm:text-[10px] md:text-xs text-muted-foreground mt-1 sm:mt-2 uppercase tracking-wider sm:tracking-widest font-medium">
        {label}
      </span>
    </div>
  );

  return (
    <div className="flex items-center justify-center gap-1 sm:gap-2 md:gap-3 w-full max-w-[280px] sm:max-w-sm mx-auto">
      <TimeBlock value={timeLeft.days} label="Days" />
      <span className="text-base sm:text-xl md:text-2xl text-primary/50 font-light -mt-4 sm:-mt-5">:</span>
      <TimeBlock value={timeLeft.hours} label="Hrs" />
      <span className="text-base sm:text-xl md:text-2xl text-primary/50 font-light -mt-4 sm:-mt-5">:</span>
      <TimeBlock value={timeLeft.minutes} label="Min" />
      <span className="text-base sm:text-xl md:text-2xl text-primary/50 font-light -mt-4 sm:-mt-5">:</span>
      <TimeBlock value={timeLeft.seconds} label="Sec" />
    </div>
  );
};
